import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Nav.css';
import logo from "../images/Sri Krishnaa Logo.png";

const closeMenu = () => {
  const chkElement = document.getElementById('chk1');
  if (chkElement) {
    chkElement.checked = false;
  }
};

function MyNavbar() {
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase(); // Convert path to lowercase

  return (
    <div>
      <Navbar className="navbar-custom-bg" expand="lg" collapseOnSelect>
        <Container>
          {/* Centered Content */}
          <div className="navbar-content text-center w-100">
            {/* First Row */}
            <div className="navbar-brand-row">
              <Navbar.Brand href="/" className="d-flex flex-column align-items-center">
                <img src={logo} alt="Sri Krishnaa Logo" className="navbar-logo" />
              </Navbar.Brand>
            </div>

            {/* Second Row */}
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="justify-content-center w-100">
                <Link to="/" className={`navbar-link ${currentPath === '/' ? 'active' : ''}`} onClick={closeMenu}>
                  HOME
                </Link>
                <Link to="/Aboutus" className={`navbar-link ${currentPath === '/aboutus' ? 'active' : ''}`} onClick={closeMenu}>
                  ABOUT US
                </Link>
                <Link to="/Menu" className={`navbar-link ${currentPath === '/menu' ? 'active' : ''}`} onClick={closeMenu}>
                  MENU
                </Link>
                <Link to="/Gallery" className={`navbar-link ${currentPath === '/gallery' ? 'active' : ''}`} onClick={closeMenu}>
                  GALLERY
                </Link>
                <Link to="/Grababitenow" className={`navbar-link ${currentPath === '/grababitenow' ? 'active' : ''}`} onClick={closeMenu}>
                  GRAB A BITE NOW
                </Link>
                <Link to="/Blog" className={`navbar-link ${currentPath === '/blog' ? 'active' : ''}`} onClick={closeMenu}>
                  BLOG
                </Link>
                <Link to="/Contactusform" className={`navbar-link ${currentPath === '/contactusform' ? 'active' : ''}`} onClick={closeMenu}>
                  CONTACT US
                </Link>
                <Link to="/Login" className={`navbar-link ${currentPath === '/login' ? 'active' : ''}`} onClick={closeMenu}>
                  LOG IN
                </Link>
                <Link to="/Signup" className={`navbar-link ${currentPath === '/signup' ? 'active' : ''}`} onClick={closeMenu}>
                  SIGN UP
                </Link>
              </Nav>
            </Navbar.Collapse>
          </div>
        </Container>
      </Navbar>
    </div>
  );
}

export default MyNavbar;
